import type { FC } from 'react'
import { motion } from 'motion/react'

/** Coche dont le trait se dessine à l'apparition (TEC-1956). `animate` à faux : tracée d'un coup. */
export const DrawnCheck: FC<{ animate?: boolean }> = ({ animate = true }) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" aria-hidden>
    <motion.path
      d="M20 6 9 17l-5-5"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      initial={{ pathLength: animate ? 0 : 1 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: animate ? 0.32 : 0, ease: 'easeOut' as const }}
    />
  </svg>
)

export default DrawnCheck
